var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],class:['feature elevation-3', _vm.feature.color],on:{"click":function($event){return _vm.$emit('click', _vm.feature)}}},[_vm._v(_vm._s(_vm.feature.name))])}
var staticRenderFns = []

export { render, staticRenderFns }